import { useWorkoutCardContext } from './workout-card'
import React from 'react'
import { CompletedBadge } from 'src/component/ui/completed-badge'

export const WorkoutCardCompletedBadge = (): React.ReactElement => {
  const { isCompleted } = useWorkoutCardContext()

  if (!isCompleted) return <></>

  return (
    <div className="self-end">
      <CompletedBadge />
    </div>
  )
}
